import { EVENT_LEVELS } from '@/modules/Events/constants';

export default {
  level: {
    event: {
      [EVENT_LEVELS.federal]: 'федеральное | федеральные | федеральные',
      [EVENT_LEVELS.municipal]: 'муниципальное | муниципальные | муниципальные',
      [EVENT_LEVELS.regional]: 'региональное | региональные | региональные',
      [EVENT_LEVELS.local]: 'локальное | локальные | локальные',
    },
    stage: {
      [EVENT_LEVELS.federal]: 'федеральный | федеральных | федеральных',
      [EVENT_LEVELS.municipal]: 'муниципальный | муниципальных | муниципальных',
      [EVENT_LEVELS.regional]: 'региональный | региональных | региональных',
      [EVENT_LEVELS.local]: 'локальный | локальных | локальных',
    },
    plural: {
      [EVENT_LEVELS.federal]: 'федерального',
      [EVENT_LEVELS.municipal]: 'муниципального',
      [EVENT_LEVELS.regional]: 'регионального',
      [EVENT_LEVELS.local]: 'локального',
    },
  },
};
